export default __webpack_public_path__ + "static/hrs-logo-748009e45d58b9b6ab62b6f6aea920ac.png";